import axios, { AxiosInstance } from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { pmsPluginUrl } from '../../../../urls'

const headers: Record<string, string> = {
	'Content-Type': 'application/json',
	'X-Requested-With': 'XMLHttpRequest',
}

const pmsInstance: AxiosInstance = axios.create({
	baseURL: pmsPluginUrl,
	headers,
})

pmsInstance.interceptors.request.use(requestInterceptor, error => Promise.reject(error))

pmsInstance.interceptors.response.use(response => response, error => {
	return responseInterceptor(error)
})

export default pmsInstance
